export default "__VITE_ASSET__BbHdveCT__"